import React from 'react';
import Layout from 'components/layout';
import Header from './components/header';
import FooterSection from 'sections/footer';
// import Markdown from 'sections/markdown';
import Support from 'sections/support';
import DownloadApp from 'sections/download-app';
import StepByStep from 'sections/step-by-step';
import SEO from 'components/seo';

const DownloadTemplate = props => {
  const { seoTitle, seoDescription } = props;

  return (
    <Layout>
      <SEO title={seoTitle} description={seoDescription} />
      <Header />
      {/* <Markdown source={data.strapiPages.content} /> */}
      <StepByStep />
      <DownloadApp />
      <Support />
      <FooterSection />
    </Layout>
  );
};

export default DownloadTemplate;
